export default "__VITE_ASSET__Euia3r31__"